import React from 'react'
import '../styles/footer.css'

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>
            Phone no :  +91 7871444915,+91 7904123737<br/>
            Email : vpacks2017@gmail.com,innovation@vpacks.net
          </p>
        </div>
        <div className="footer-section">
          <h4>Address</h4>
          <p>
             111,jeeva street,sellur,<br/>madurai,<br/>TamilNadu 625002
          </p>
         
        </div>
        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-icons">
            
            <a href="https://www.instagram.com/vpacks_2017?utm_source=qr&igsh=bG1uYnc1b2RnY3Fn" target="_blank" rel="noopener noreferrer">Instagram</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 V Packs. All rights reserved.</p>
      </div>
    </footer>
  )
}
